import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { Router, ActivatedRoute, Data } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { Constantes } from '../../../shared/constantes';

import { ConsultaInternaService } from '../..//services/consulta-interna.service';

import { AutenticacionService } from '../../../shared/services/autenticacion.service';

import { ConsultaSolicitud } from '../../../shared/models/consulta-solicitud';
import { TipoIdentificacion } from '../../../shared/models/tipo-identificacion';
import { Mensaje } from '../../../shared/models/mensaje';

import { AlertaService } from '../../../shared/components/alerta/alerta.service';
import { SpinnerService } from '../../../shared/components/spinner/spinner.service';

@Component({
  selector: 'app-consulta-runt',
  templateUrl: './consulta-runt.component.html'
})
export class ConsultaRuntComponent implements OnInit {
  @ViewChild('f') form: NgForm;
  @ViewChild('captcha') captcha: NgModel;

  reCaptchaSiteKey: string = '';
  tiposIdentificacionSolicitud: TipoIdentificacion[] = [];
  formEnviado: boolean;
  consultaSolicitud: ConsultaSolicitud = <ConsultaSolicitud>{};

  constructor(private translate: TranslateService,
    private autenticacionService: AutenticacionService,
    private consultaInternaService: ConsultaInternaService,
    private alertaService: AlertaService,
    private spinnerService: SpinnerService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.autenticacionService.logout();

    this.activatedRoute.data
      .subscribe(
      (data: Data) => {
        this.reCaptchaSiteKey = data['siteKey'];
      }
      );

    this.mostrarMensajeSession();
  }

  mostrarMensajeSession() {
    var mensaje = this.autenticacionService.getMensaje();
    if (mensaje != null) {
      this.alertaService.warning(mensaje);
      this.autenticacionService.setMensaje(null);
    }
  }

  consultarSolicitud() {
    this.formEnviado = true;

    if (this.form.valid) {
      this.spinnerService.show();

      this.consultaInternaService.consultarSolicitud(this.consultaSolicitud)
        .subscribe(
        (data) => {
          if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {

            this.autenticacionService.login(this.consultaSolicitud)
              .subscribe(
              (data) => {
                if (data.codigoRespuesta == Constantes.CODIGO_RESPUESTA_OK) {
                  //redirecciona al detalle
                  this.router.navigate(['/detalle-runt', this.consultaSolicitud.numeroSolicitud]);
                } else {
                  this.alertaService.warning(data.mensaje);
                }
              },
              (error) => { this.alertaService.error('Error al generar el token de seguridad, por favor intente mas tarde.') }
              );

          } else {
            this.alertaService.warning(data.mensaje);
            this.limpiarConsulta();
          }
        },
        (error) => { this.alertaService.error('Error al consultar la solicitud, por favor intente mas tarde.') });
    } else {
      this.limpiarCaptcha();
    }
  }

  limpiarConsulta() {
    this.formEnviado = false;
    this.consultaSolicitud = <ConsultaSolicitud>{};

    this.limpiarCaptcha();
  }

  limpiarCaptcha() {
    this.consultaSolicitud.reCaptcha = '';
    this.captcha.reset();
  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/QA/HistoricoConductor/frontend/src/app/public/components/consulta-runt/consulta-runt.component.ts